export default {
    methods: {
        async getFiltrar() {

            await this.getDataGet({ route: 'get_afldescargar', data: 'descargar' })
                // frontend await this.searchGetIdb({tabla:'afiliacion_registro'})
        },
        getPdf() {
            window.open(this.url + '/api/pdf/registrosdescargar?&token=' + this.token, '_blank')
        },
    },
}